"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.provider.stripe.description': '使用 Stripe 通过信用卡、借记卡和数字钱包支付',
};
